import { Component, OnInit,ViewChild } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Template/template.html'
})

export class TemplateComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public StageList: any = [];
    public PeriodList: any = [];
    public TeamList: any = [];
    public ReviewTemplateList: any = [];
    public ReviewEmployeeList : any = [];
    public ReviewTemplateId:any = null;
    public TemplateFilterFlag: any;
    public showLoader = false;
    filter: any = {PeriodId:null};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.TemplateFilterFlag=JSON.parse(localStorage.getItem('TemplateFilters'));
        if(this.TemplateFilterFlag!=null && typeof this.TemplateFilterFlag != 'undefined'){
          this.filter=JSON.parse(localStorage.getItem('TemplateFilters'));
          
          localStorage.removeItem("TemplateFilters")
                                                           
        }   
    }

    ngOnInit() {
        this.getPeriodList();
        this.getTemplateByPeriod();
      
    }

    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }



    public setFilters(){
      
    this.filter = { 'PeriodId': this.filter.PeriodId};
    localStorage.setItem("TemplateFilters",JSON.stringify(this.filter));
}
public getTemplateByPeriod(){
 this.showLoader = true;
 if(this.filter.PeriodId =="null")
 this.filter.PeriodId=null;                                                
        this._httpService.ajaxPost('ReviewTemplate/getTemplateByPeriod', {"PeriodId":this.filter.PeriodId,"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewTemplateList = data["ReviewTemplateList"];
                
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    public getPeriodList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetPeriod', null).subscribe(
            data => {
                this.PeriodList = data["PeriodList"];
                this.PeriodList =this.PeriodList.filter( x => x.IsActive === true);
            },
            err => {
                this.showLoader = false;
              
            },
            () => {
                this.showLoader = false;
            }
        );
    }

  
     public setupKRA(){
        if(this.ReviewTemplateId != null){
            localStorage.setItem("ReviewTemplateId",JSON.stringify(this.ReviewTemplateId));
            this._route.navigateByUrl("/setupKRA");
        }
    }

    public printPDf(id){
 
         
            localStorage.setItem("ReviewEmployeePrintId",JSON.stringify(id));
            this._route.navigateByUrl("/ReviewEmployeePrint");
           
    }
         
        
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Template/Template.component.ts
 **/